import React from "react";

const ADOItemsDropdown = props => {
  const { items, checkedList, deleteItem, addItem } = props;

  return items.map(item => (
    <div
      key={item.id}
      className="search-dropdown-item"
      onClick={() => {
        if (checkedList.has(item.id)) {
          deleteItem(item);
        } else {
          addItem(item);
        }
      }}
    >
      <span
        className={
          checkedList.has(item.id) ? "selected-checkbox" : "empty-checkbox"
        }
      ></span>
      <span className="marginleft10">
        <b>{item.id}</b>
        {` | ${item.name}`}
      </span>
    </div>
  ));
};

export default ADOItemsDropdown;
